import { ReactNode } from "react";
import { cn } from "utils";

export const Card = ({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) => {
  return (
    <div
      className={cn(
        "border-[1px] border-[#eeeeee] p-[10px] rounded-[10px]",
        className
      )}>
      {children}
    </div>
  );
};
